import React from 'react';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';

export interface MobileListField {
  label: string;
  value: React.ReactNode;
}

interface MobileListCardProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  fields: MobileListField[];
  actions?: React.ReactNode;
  onClick?: () => void;
}

const MobileListCard: React.FC<MobileListCardProps> = ({ title, subtitle, fields, actions, onClick }) => (
  <Card variant="outlined" onClick={onClick} sx={{ cursor: onClick ? 'pointer' : 'default' }}>
    <CardContent sx={{ '&:last-child': { pb: 2 } }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, alignItems: 'flex-start' }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="subtitle1" fontWeight={600} noWrap>{title}</Typography>
          {subtitle && <Typography variant="body2" color="text.secondary" noWrap>{subtitle}</Typography>}
        </Box>
        {actions && <Stack direction="row" spacing={0.25} onClick={event => event.stopPropagation()}>{actions}</Stack>}
      </Box>
      <Stack spacing={0.5} sx={{ mt: 1.5 }}>
        {fields.map(field => (
          <Box key={field.label} sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
            <Typography variant="caption" color="text.secondary">{field.label}</Typography>
            <Typography variant="body2" textAlign="right">{field.value}</Typography>
          </Box>
        ))}
      </Stack>
    </CardContent>
  </Card>
);

export default MobileListCard;
